import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

// One-click direct access: /direct?token=<JWT>&next=/dashboard
// Exchanges the URL token for an httpOnly session cookie via the backend,
// then routes to `next` (default /dashboard). No JS ever holds the token.
export default function Direct() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { checkAuth } = useAuth();

  useEffect(() => {
    const token = params.get("token");
    const next = params.get("next") || "/dashboard";
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        await api.post("/auth/exchange", { token });
        // Use checkAuth as the single source of truth so any concurrent
        // /me request (e.g. from AuthProvider mount) can't clobber user state.
        await checkAuth();
        window.history.replaceState(null, "", next);
        navigate(next, { replace: true });
      } catch (err) {
        console.error("Direct token exchange failed", err);
        navigate("/login", { replace: true });
      }
    })();
  }, [params, navigate, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]" data-testid="direct-login">
      <div className="text-zinc-500 text-sm font-mono">Signing you in…</div>
    </div>
  );
}
